module.exports = __webpack_public_path__ + "img/users.f75cbe4d.svg";